import { colors } from '@flowwai-frontend/shared/style-guide'

const ltpUserManagementTheme = {
   light: {
      ltpUserHeader: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         refreshIconColor: '!bg-base-white'
      },
      ltpUserBody: {
         defaultBorderColor: 'border-gray-300',
         dividerColor: 'border-gray-200',
         headerTextColor: 'text-gray-900',
         labelColor: 'text-gray-500',
         descriptionColor: 'text-gray-600',
         titleColor: 'text-gray-900',
         subtitleColor: 'text-gray-600',
         valueColor: 'text-gray-800',
         baseWhiteColor: 'bg-base-white',
         userIconColorBg: 'bg-gray-100',
         iconColor: colors['gray-600'],
         avatarBackgroundColor: 'bg-purple-100',
         avatarTextColor: 'text-purple-600',
         statusBadgeBackgroundColor: 'bg-green-100',
         statusDotColor: 'bg-green-500',
         statusTextColor: 'text-green-800',
         errorTextColor: 'text-error-500',
         whiteHoverBgColor: 'hover:bg-gray-50'
      },
      ltpUserTabs: {
         activeTabTextColor: 'text-primary-700',
         activeTabBorderColor: 'border-primary-600',
         inactiveTabTextColor: 'text-gray-500',
         tabContainerBorderColor: 'border-gray-200'
      },
      ltpUserActions: {
         backButtonColor: 'text-primary-600',
         backButtonHoverColor: 'hover:text-primary-700',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         actionLabelColor: 'text-gray-700',
         requiredIconColor: 'text-error-700',
         actionIcon: {
            updateUserIconColor: colors['cyan-600'],
            updateUserBgColor: 'bg-cyan-100',
            deactivateUserIconColor: colors['red-600'],
            deactivateUserBgColor: 'bg-red-100'
         }
      },
      ltpUserExpandableDetails: {
         borderColor: 'border-gray-300',
         titleColor: 'text-gray-800',
         labelColor: 'text-gray-600',
         valueColor: 'text-gray-800',
         chevronColor: 'text-gray-500',
         contentBackgroundColor: 'bg-gray-50'
      },
      ltpUserLogs: {
         bgColor: 'bg-gray-100',
         ltpUserLogsHeader: {
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900',
            refreshIconColor: '!bg-base-white',
            closeIconColor: colors['gray-500'],
            filterButtonStyle: 'border-primary-600'
         },
         ltpUserLogsTable: {
            headerTextColor: 'text-gray-700',
            rowTextColor: 'text-gray-800',
            borderColor: 'border-gray-200'
         },
         ltpUserLogCard: {
            borderColor: 'border-gray-300',
            titleTextColor: 'text-gray-800',
            timestampTextColor: 'text-gray-600',
            chevronColor: 'text-gray-500',
            descriptionBackgroundColor: 'bg-gray-50',
            descriptionTextColor: 'text-gray-700'
         },
         ltpUserLogDetailedView: {
            defaultBorderColor: 'border-gray-200',
            defaultTextColor: 'text-gray-800',
            headerTextColor: 'text-gray-900',
            sectionTitleColor: 'text-gray-600',
            labelColor: 'text-gray-600',
            valueColor: 'text-gray-800',
            separatorColor: 'text-gray-800',
            reasonTextColor: 'text-gray-800',
            noContentColor: 'text-gray-500',
            iconColor: colors['primary-500'],
            iconBgColor: 'bg-primary-200'
         },
         filterConditionPills: {
            borderColor: 'border-gray-300',
            iconColors: colors['primary-600'],
            propertyIconColor: colors['primary-600'],
            tooltipArrowColor: colors['gray-900'],
            addFilterButton: {
               iconColor: colors['primary-600'],
               textColor: 'text-primary-700',
               borderColor: 'border-primary-600'
            },
            clearFilterButton: {
               iconColor: colors['gray-600'],
               textColor: 'text-gray-600'
            }
         }
      },
      ltpUserLogModal: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         borderColor: 'border-gray-300',
         containerBgColor: 'bg-base-white'
      }
   },
   dark: {}
}

export default ltpUserManagementTheme
